/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ChestPainIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M49.2 13.5c-2.6-7.8-11-12-18.8-9.4-2 .7-3.9 1.8-5.4 3.2l-.2-.2c-.1-.1-.2-.2-.3-.2-.5-.4-1-.8-1.6-1.2-3.3-2.2-7.3-2.9-11.2-2.1-3.8.8-7.1 3.1-9.3 6.4C.5 12.9-.3 16.4.1 19.9c.3 2.9 1.5 5.6 3.4 7.8 3.6 3.9 7.3 7.8 10.8 11.6l.4.4c1.3 1.4 2.7 2.8 4 4.2l.7.7c1.6 1.4 3.5 2.1 5.5 2.1 2.3 0 4.6-.9 6.2-2.8l10-10.6c.4-.5.9-.9 1.3-1.4l.4-.5c1.1-1.2 2.3-2.4 3.4-3.7 2.1-2.3 3.4-5.4 3.6-8.5.3-1.9.1-3.8-.6-5.7zM23.6 9.4l-3.9 10.9v.1c-.2.4-.2.8 0 1.2.1.3.4.5.7.6.3.1.6.1.8-.1l1.8-.5c.4-.1.9-.2 1.3-.4l3.2-.9L24 31.5c-.1.2-.1.4-.1.5-.1.6.2 1.1.8 1.3.5.2 1.1 0 1.4-.5.1-.2.2-.3.2-.5 1.4-4.3 2.8-8.7 4.1-13 .2-.3.2-.6.1-.9-.1-.3-.3-.6-.6-.7-.4-.2-.8-.2-1.1 0l-5.4 1.5-.9.2.2-.7c.2-.7.5-1.4.7-2.1l.5-1.4c.6-1.8 1.3-3.5 1.9-5.3.1-.3.2-.5.4-.7 2.6-2.8 6.4-4.1 10.1-3.7 3.7.3 7.1 2.4 9.1 5.6 3.2 4.9 2.6 11.4-1.5 15.6-3.1 3.3-6.3 6.7-9.4 10l-4.8 5.1c-.7.9-1.7 1.6-2.7 2.1-2.3 1-5 .4-6.7-1.5-5-5.3-10-10.7-14.8-15.8C3.2 24.2 2 21 2.1 17.7 2.2 14.4 3.6 11.3 6 9c2.3-2.2 5.4-3.4 8.6-3.4 1.2 0 2.4.2 3.5.5 2 .6 3.8 1.6 5.3 3.1.3.1.3.1.2.2z' />
		</svg>
	)
}

export default ChestPainIcon
